import { useMemo } from 'react';
import { INewCartShipment } from '../ICart';

const useProductIds = (shipments: INewCartShipment[]) => {
  return useMemo(() => {
    const shipmentIDList: string[] = [];
    if (!shipments) {
      return '';
    }

    shipments.forEach(({ entries }) => {
      entries.forEach(({ product }) => {
        shipmentIDList.push(product.code);
      });
    });
    return shipmentIDList.join('|');
  }, [shipments]);
};

export default useProductIds;
